import React, {useState, useContext} from "react";
import { NameContext } from "../context/NameContext";
import { PaperBG, UnderlineSketch, MonoButton } from "../kits";

const LogbookEntry = () => {
    const { selfIsNameEntered} = useContext(NameContext);
    const [ entry, setEntry ] = useState("");
    const [ showMore, setShowMore ] = useState(false);
    const [ goal, setGoal ] = useState(""); 
    const [ time, setTime ] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        // Hier kannst du den Code hinzufügen, um die Einträge zu speichern
        console.log("Eintrag gespeichert:", entry, goal, time);
        setEntry("");
        setGoal("");
        setTime("");




    };

    return (
        <PaperBG className="py-12 px-6">
          <form
            onSubmit={handleSubmit}
            className="max-w-2xl mx-auto bg-white border border-black rounded-xl p-6 font-mono space-y-6 text-black shadow-md"
          >
            <div className="text-center space-y-3">
              <h2 className="text-xl">Willkommen im Onboarding-Logbuch</h2>
              <p className="text-sm text-gray-600">
                Eine kurze Notiz für dich selbst – nicht für uns.
              </p>
            </div>
    
            <div className="relative">
              <label className="block text-sm mb-1">Wo befindest du dich gerade?</label>
              <textarea
                value={entry}
                onChange={(e) => setEntry(e.target.value)}
                placeholder="Ich stehe gerade vor..."
                rows="3"
                className="w-full border border-black bg-gray-50 rounded-md px-4 py-2 focus:outline-none focus:ring-1 focus:ring-gray-800"
              ></textarea>
              <span className="absolute left-0 -bottom-1 w-full h-[6px]">
                <UnderlineSketch />
              </span>
            </div>
    
            {showMore && (
              <>
                <div>
                  <label className="block text-sm mb-1">Was möchtest du lernen?</label>
                  <input
                    type="text"
                    value={goal}
                    onChange={(e) => setGoal(e.target.value)}
                    className="w-full border border-black bg-gray-50 rounded-md px-4 py-2 focus:outline-none focus:ring-1 focus:ring-gray-800"
                  />
                </div>
                <div>
                  <label className="block text-sm mb-1">Wie viel Zeit hast du?</label>
                  <input
                    type="text"
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    className="w-full border border-black bg-gray-50 rounded-md px-4 py-2 focus:outline-none focus:ring-1 focus:ring-gray-800"
                  />
                </div>
              </>
            )}
    
            <div className="text-right">
              <button
                type="button"
                onClick={() => setShowMore(!showMore)}
                className="text-sm text-gray-600 underline hover:text-black"
              >
                {showMore ? "Weniger anzeigen" : "Mehr hinzufügen"}
              </button>
            </div>
    
            <MonoButton type="submit" className="w-full">
              Eintragen und starten
            </MonoButton>
          </form>
        </PaperBG>
      );
    };
    
    export default LogbookEntry;
    